import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    scriptUrl: String,
    nzmform: String
  };
  static targets = ["container"];

  connect() {
    if (this.scriptUrlValue) {
      this.loadScript(this.scriptUrlValue);
    }
  }

  loadScript(url) {
    const scriptTag = document.createElement("script");
    scriptTag.src = url;
    scriptTag.async = true;

    scriptTag.setAttribute("data-nzmform", this.nzmformValue);

    this.containerTarget.appendChild(scriptTag);
  }
}
